export enum NoticeQueryType {
  Id = 'notice_uid',
  Page = 'notice_page',
}
